module.exports = __webpack_public_path__ + "static/media/active_campaign_icon.7584ddc7.svg";